export default __webpack_public_path__ + "_/images/logos/egb-com-black-17e4ec5b1d6395de5eaf8d88df83e342f15a5ff5d25aa707717f584f024f1eff.svg";